<script>
import Textfield from 'linna/components/Textfield'

import Led from '@/components/snippets/Led'
import StyledButton from '@/components/snippets/StyledButton'

export default {
  name: 'Decoder',

  components: {
    Led,
    StyledButton,
    Textfield
  },

  data () {
    return {
      messageToDecode: '',
      lastDecodedMessage: '',
      powerBrickIsInserted: false,
      isOn: null
    }
  },

  computed: {

    inventoryPowerBrick () {
      const items = this.$store.getters.inventoryItemsByType.decoderPowerBrick
      return items ? items[0] : null
    },

    canInsertPowerBrick () {
      return !!this.inventoryPowerBrick && !this.powerBrickIsInserted
    }

  },

  methods: {

    insertPowerBrick () {
      if (
        !this.powerBrickIsInserted &&
        this.canInsertPowerBrick
      ) {
        this.powerBrickIsInserted = true
        this.$store.dispatch('destroyInventoryItemById', this.inventoryPowerBrick.id)
      }
    },

    togglePower () {
      this.isOn = !this.isOn
    },

    decodeMessage () {
      this.lastDecodedMessage = this.messageToDecode + 'rot13'
    }

  }

}
</script>

<template>
  <div class="c-decoder">
    <div class="c-decoder-content">

      <styled-button
        :disabled="!canInsertPowerBrick"
        class="c-decoder-power-socket"
        @click="insertPowerBrick"
      >
        {{ powerBrickIsInserted ? 'x' : 'o' }}
      </styled-button>

      <styled-button
        :disabled="!powerBrickIsInserted"
        class="c-decoder-power-button"
        @click="togglePower"
      >
        PWR
      </styled-button>

      <textfield
        :value.sync="messageToDecode"
        :inline="true"
        :disabled="!isOn"
        :placeholder="isOn ? 'Message to decode...' : ''"
      />

      <styled-button
        :disabled="!(isOn && messageToDecode)"
        @click="decodeMessage"
      >
        Decode
      </styled-button>

      <led :on="isOn" />

      <span
        v-if="isOn && lastDecodedMessage"
        class="c-decoder-output"
      >
        {{ lastDecodedMessage }}
      </span>

    </div>
  </div>
</template>

<style lang="scss">

.c-decoder {
  @include pad-loose-even;
  background-color: $very-dark;
}

</style>
